export default __webpack_public_path__ + "static/media/events-banner.afb6e535.svg";